// extracted by mini-css-extract-plugin
export var container = "_u5-0";
export var table = "_u5-2";
export var tableWrapper = "_u5-1";